/**
 * Slider scripts.
 * 
 * Handles all functionality related to creating sliders.
 */

/** Dependencies -------------------------------------------- */

// External

import EmblaCarousel from 'embla-carousel'

import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin( ScrollTrigger )

// Design system

import { baseSpacing } from '../blocks/style-guide'

/** The beef ------------------------------------------------ */

export default class Slider {

    /** Setup ----------------------------------------------- */

    constructor( sliderClassName, slideClassName, config = {} ) {

        this.sliderClassName = sliderClassName
        this.slideClassName = slideClassName

        this.config = {
            slideDuration : 0.75,
            slideStagger  : 1,
            ...config
        }
    }

    init() {

        this.sliders = document.querySelectorAll( `.${this.sliderClassName}` )

        if ( this.sliders.length ) {

            document.addEventListener( 'click', this.handleButtonClick.bind( this ) )

            for ( const [ index, slider ]  of this.sliders.entries() ) {

                const container = slider.querySelector( '.overrides-slider-container' ) || slider.querySelector( `.${this.sliderClassName}__container` )

                const emblaCarouselApi = EmblaCarousel(
                    slider,
                    {
                        container      : container,
                        slidesToScroll : 'auto'
                    }
                )

                emblaCarouselApi
                    .on( 'select', this.toggleButtonStates )
                    .on( 'init', this.toggleButtonStates )
                    .on( 'reInit', this.toggleButtonStates )
                    .on( 'select', this.handleSlideSelect )

                slider.emblaCarouselApi = emblaCarouselApi
            }

            gsap.set( `.${this.slideClassName}`, { opacity: 0, x: baseSpacing * 6 } )
        }
    }

    animate() {

        for ( const slider of this.sliders ) {

            const slides = slider.querySelectorAll( `.${this.slideClassName}` )
            const sliderTimeline = gsap.timeline( { paused: true } )
                .to( slides, { opacity: 1, x: 0, duration: this.config.slideDuration, stagger: { amount: this.config.slideStagger } } )

            ScrollTrigger.create({
                animation : sliderTimeline,
                trigger   : slider,
                once      : true
            })
        }
    }

    /** Handlers ------------------------------------------------ */

    handleButtonClick( event ) {

        if ( event.target.matches( `.${this.sliderClassName}__button` ) ) {
            
            const parentSlider = event.target.closest( `.${this.sliderClassName}` )
            const emblaCarouselApi = parentSlider.emblaCarouselApi

            if ( event.target.matches( '.goes-forwards' ) ) {
                emblaCarouselApi.scrollNext()
            }
            else {
                emblaCarouselApi.scrollPrev()
            }
        }
    }

    handleSlideSelect( emblaCarouselApi, eventType ) {
        console.log( emblaCarouselApi )
    }

    /** Utils ----------------------------------------------- */

    toggleButtonStates( emblaCarouselApi ) {

        const slider = emblaCarouselApi.rootNode()

        const prevButton = slider.querySelector( '.goes-backwards' )
        const nextButton = slider.querySelector( '.goes-forwards' )

        if ( emblaCarouselApi.canScrollPrev() ) {
            prevButton.removeAttribute( 'disabled' )
        }
        else {
            prevButton.setAttribute( 'disabled', 'disabled' )
        }

        if ( emblaCarouselApi.canScrollNext() ) {
            nextButton.removeAttribute( 'disabled' )
        }
        else {
            nextButton.setAttribute( 'disabled', 'disabled' )
        }
    }

}
